<div class="delete-reward-modal-root" *transloco="let t">
  <div *ngIf="loading" class="loading">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
  <div class="header">
    <div class="title">{{ t('delete-reward-modal.title') }}</div>
    <button id="close-dialog-icon" (click)="onDialogClose()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="body">
    <p class="text-warning">
      {{ t('delete-reward-modal.warning') }}
    </p>
    <p class="text-info">
      {{ t('delete-reward-modal.info') }}
    </p>
    <p class="text-danger">
      {{ t('delete-reward-modal.danger') }}
    </p>
  </div>
  <div class="footer">
    <button mat-stroked-button color="primary" (click)="onDialogClose()">
      {{ t('delete-reward-modal.cancel') }}
    </button>
    <button mat-flat-button color="warn" (click)="deleteReward()">
      <nb-icon icon="trash-2-outline"></nb-icon>
      <span>{{ t('delete-reward-modal.delete') }}</span>
    </button>
  </div>
</div>
